const messages = {
    fr: {
        global: {
            chargement: 'Chargement...',
            vide: '',
        },
        error: {
            titre: 'Pas de chance...',
            message: 'La page que vous désiriez voir n\'est malheureusement plus accessible pour l\'instant, réessayez plus tard.',
            messageSuite: 'Vous pouvez revenir à la liste de nos activités en cliquant',
            messageSuiteActivite: 'Vous pouvez revenir à l\'activité en cliquant',
            messageLien: 'sur ce lien',
        },
        catalogue: {
            btnVoirActivite: 'Plus d\'info',
            btnRecherche: 'Rechercher',
            btnReset: 'Effacer les filtres',
            typePublic: 'Type de public',
            typeTheme: 'Thème',
            motCle: 'Mot-clé',
            dates: 'Dates',
            entre: 'entre',
            et: 'et',
            aucun: 'Tous/Toutes',
            accesHandicape: 'AniJHan',
            anneeNaissance: 'Année de naissance',
            formatAnnee: 'Année de naissance',
            oui: 'Oui',
            non: 'Non',
            mobilite: 'Mobilité',
            autonomie: 'Autonomie',
            lieuDepart: 'Lieu de départ',
            lieuActivite: 'Lieu d\'actitivé',
            aucunTransport: 'Aucun transport organisé',
            regional: 'Régionale',
            obligatoire: 'Ce filtre est obligatoire',
            messagePreliminaire: 'Pour accéder au catalogue de nos activités, veuillez d\'abord compléter les informations suivantes :',
            resultats: 'Résultat(s) :',
            tous: {
                typePublique: 'Public (tous)',
                themes: 'Tous les thèmes',
                mobilites: 'Mobilité (tous)',
                rythmes: 'Rythme (tous)',
                autonomies: 'Tous les types d\'autonomie',
                lieuxDeparts: 'Lieu de départ (tous)',
                lieuxActivite: 'Destination (tous)',
                regionales: 'Toutes les régions',
            },
        },
        activity: {
            type: 'Type',
            dateDebut: 'Début',
            dateFin: 'Fin',
            organisateur: 'Organisateur',
            public: 'Public',
            prixBase: 'Prix de base',
            prix: 'Prix',
            lieu: 'Lieu',
            departs: 'Départs',
            themes: 'Thèmes',
            tags: 'Tags',
            periode: 'Période',
            periodes: 'Périodes',
            btnInscription: 'M\'inscrire',
            btnListeAttente: 'M\'inscrire sur liste d\'attente',
            formBtnInscriptionListeAttente: 'M\'inscrire sur liste d\'attente',
            inscriptionImpossible: 'Inscriptions non autorisées ou l\'activité est complète',
            embarquements: 'Lieux d\'embarquement',
            btnInscriptionModalites: 'Voir les modalités d\'inscription',
            modalites: 'Modalités d\'inscription',
            btnRevenirCatalogue: 'Toutes nos activités',
            btnRevenirListe: 'Revenir à la liste',
            reductionMC: 'Avantage MC',
            reductionBIM: 'Avantage BIM',
            toolTipReductionMC: 'Avantage destiné aux membres de la Mutualité chrétienne (en ordre de cotisation à l\'assurance complémentaire)',
            toolTipReductionBIM: 'Avantage destiné aux membres de la Mutualité chrétienne bénéficiaires de l\'intervention majorée (en ordre de cotisation à l\'assurance complémentaire)',
            lienLieu: 'Lieu :',
            lienConditions: 'Conditions de l\'activité',
            documents: 'Documents à rendre',
            documentObligatoire: 'Obligatoire',
            telechargerDocument: 'Télécharger le document à remplir',
            optins: 'Conditions d\'inscription',
            consulterConditions: 'Consulter',
            prixJour: 'jour',
            prixSemaine: 'semaine',
            partagerTips: 'copier le lien de partage de cette activité',
            partager: 'Partager cette activité',
            confirmationPartage: 'Le lien a été copié dans votre presse-papiers',
        },
        slider: {
            precedent: 'Précédent',
            suivant: 'Suivant',
        },
        form: {
            btnRevenirActivite: 'Revenir à l\'activité',
            btnInscription: 'Valider mon inscription',
            fichier: 'Vous pouvez joindre un fichier à ce formulaire (optionnel)',
            obligatoire: 'Ce champ est obligatoire',
            ageConstraintValidationError: 'Les tranches d\'âge définies pour cette activité ne vous permettent pas de participer',
            noContingentSelectedError: 'Veuillez séléctionner au moins un contingent à l\'une des étapes précédentes',
            contingentNotSelectableMessage: 'Cette option n\'est pas disponible pour votre âge',
            formatInvalide: 'Ce champ doit respecter un format valide',
            conditions: 'Vous devez accepter les conditions avant de pouvoir valider votre inscription',
            lienConditions: 'Voir les conditions',
            formatTel: 'Formats conseillés : 0032 xx xx xx xx ou 0032 x xx xx xx',
            formatMobile: 'Format conseillé : 0032 xxx xx xx xx',
            formatNrn: 'xx xx xx xxx-xx',
            trouverNrn: 'Vous trouverez votre numéro de registre national au dos de votre carte d\'identité',
            autre: 'Autre',
            btnSuivant: 'Continuer',
            btnPrecedent: 'Étape précédente',
            prixTotal: 'Prix total de votre inscription',
            erreurMessage: 'Une erreur s\'est produite',
            contingents: 'Options',
            contingentsLibres: 'Options',
            contingentsObligatoires: 'Options',
            contingentComplet: 'COMPLET',
            periodeComplet: 'COMPLET',
            contingentAttente: 'Ce groupe est complet, inscrivez-vous tout de même sur liste d\'attente. Notre secrétariat vous recontactera si une place se libère.',
            periodeAttente: 'Cette période est complète, inscrivez-vous tout de même sur liste d\'attente. Notre secrétariat vous recontactera si une place se libère.',
            anijhan : 'Accessible aux personnes en situation de handicap',
            deposerDocument : 'Déposez ici votre document ou cliquez pour sélectionner votre document',
            erreurMaxPlaces : 'Vous êtes autorisé à réserver entre 1 et {nb_places} places sur cette activité',
            periodes: {
                du: 'du',
                au: 'au',
                obligatoire: 'Vous devez sélectionner au moins une des périodes proposées',
                garderie: 'Garderie',
                transport: 'Transport',
            },
            options: {
                obligatoire: 'Sélectionnez une des options proposées',
            },
            adresse: {
                adresse: 'Rue',
                ville: 'Ville',
                numero: 'Numéro',
                boite: 'Boîte',
                cp: 'Code postal/Localité',
                pays: 'Pays',
                facturationIdentique: 'Adresse de facturation identique à l\'adresse principale',
                urgenceIdentique: 'Adresse d\'urgence identique à l\'adresse principale',
                prenom : 'Prénom',
                nom : 'Nom',
                email : 'Email',
                tel : 'Téléphone',
                mobile : 'GSM',
            },
            sexes: {
                homme: 'Masculin',
                femme: 'Féminin',
            },
            pays: {
                belgique: 'Belgique',
                luxembourg: 'Luxembourg',
                france: 'France',
            },
            langues: {
                fr: 'Français',
                nl: 'Néerlandais',
                lu: 'Luxembourgeois',
                de: 'Allemand',
            },
            nationalites: {
                be: 'Belge',
                lu: 'Luxembourgeoise',
                de: 'Allemande',
                fr: 'Française',
            },
            resume: {
                titre: 'Résumé de votre inscription',
            },
            paiement: {
                parJour: ' / jour',
                parPeriode: ' / période',
            },
            btnPayerEnLigne: 'Payer mon inscription',
            nrn: 'Numéro de registre national',
            avantagesMC: 'Avantage MC',
            avantagesSwicthLabel: 'Je suis membre MC et je souhaite bénéficier de mon avantage',
            lienInscriptionAlternative: 'Lien vers processus d\'inscription alternatif',
            lienInscriptionForm: 'Revenir sur le formulaire d\'inscription',
            erreurDejaInscrit: '<p>Il semble que vous soyez déjà inscrit à cette activité, il n\'est pas possible d\'enregistrer votre inscription.</p>',
        }
    },
    de: {
        global: {
            chargement: 'Chargement...',
            vide: '',
        },
        error: {
            titre: 'Pas de chance...',
            message: 'La page que vous désiriez voir n\'est malheureusement plus accessible pour l\'instant, réessayez plus tard.',
            messageSuite: 'Vous pouvez revenir à la liste de nos activités en cliquant',
            messageSuiteActivite: 'Vous pouvez revenir à l\'activité en cliquant',
            messageLien: 'sur ce lien',
        },
        catalogue: {
            btnVoirActivite: 'Plus d\'info',
            btnRecherche: 'rechercher',
            btnReset: 'Effacer les filtres',
            typePublic: 'Type de public',
            typeTheme: 'Thème',
            motCle: 'Mot-clé',
            dates: 'Dates',
            entre: 'entre',
            et: 'et',
            aucun: 'Tous/Toutes',
            accesHandicape: 'AniJHan',
            anneeNaissance: 'Année de naissance',
            formatAnnee: 'Année de naissance',
            oui: 'Oui',
            non: 'Non',
            mobilite: 'Mobilité',
            autonomie: 'Autonomie',
            lieuDepart: 'Lieu de départ',
            lieuActivite: 'Lieu d\'actitivé',
            aucunTransport: 'Aucun transport organisé',
            regional: 'Régionale',
            obligatoire: 'Ce filtre est obligatoire',
            messagePreliminaire: 'Pour accéder au catalogue de nos activités, veuillez d\'abord compléter les informations suivantes :',
            resultats: 'Résultat(s) :',
            tous: {
                typePublique: 'Public (tous)',
                themes: 'Tous les thèmes',
                mobilites: 'Mobilité (tous)',
                autonomies: 'Tous les types d\'autonomie',
                lieuxDeparts: 'Lieu de départ (tous)',
                lieuxActivite: 'Destination (tous)',
                regionales: 'Toutes les régions',
            },
        },
        activity: {
            type: 'Type',
            dateDebut: 'Début',
            dateFin: 'Fin',
            organisateur: 'Organisateur',
            public: 'Public',
            prixBase: 'Prix de base',
            prix: 'Prix',
            lieu: 'Lieu',
            departs: 'Départs',
            themes: 'Thèmes',
            tags: 'Tags',
            periode: 'Période',
            periodes: 'Périodes',
            btnInscription: 'M\'inscrire',
            btnListeAttente: 'M\'inscrire sur liste d\'attente',
            formBtnInscriptionListeAttente: 'M\'inscrire sur liste d\'attente',
            inscriptionImpossible: 'Inscriptions non autorisées ou l\'activité est complète',
            embarquements: 'Lieux d\'embarquement',
            btnInscriptionModalites: 'Voir les modalités d\'inscription',
            modalites: 'Modalités d\'inscription',
            btnRevenirCatalogue: 'Toutes nos activités',
            btnRevenirListe: 'Revenir à la liste',
            reductionMC: 'Avantage MC',
            reductionBIM: 'Avantage BIM',
            toolTipReductionMC: 'Avantage destiné aux membres de la Mutualité chrétienne (en ordre de cotisation à l\'assurance complémentaire)',
            toolTipReductionBIM: 'Avantage destiné aux membres de la Mutualité chrétienne bénéficiaires de l\'intervention majorée (en ordre de cotisation à l\'assurance complémentaire)',
            lienLieu: 'Lieu :',
            lienConditions: 'Conditions de l\'activité',
            documents: 'Documents à rendre',
            documentObligatoire: 'Obligatoire',
            telechargerDocument: 'Télécharger le document à remplir',
            optins: 'Conditions d\'inscription',
            consulterConditions: 'Consulter',
            prixJour: 'jour',
            prixSemaine: 'semaine',
            partagerTips: 'copier le lien de partage de cette activité',
            partager: 'Partager cette activité',
            confirmationPartage: 'Le lien a été copié dans votre presse-papiers',
        },
        slider: {
            precedent: 'Précédent',
            suivant: 'Suivant',
        },
        form: {
            btnRevenirActivite: 'Revenir à l\'activité',
            btnInscription: 'Valider mon inscription',
            fichier: 'Vous pouvez joindre un fichier à ce formulaire (optionnel)',
            obligatoire: 'Ce champ est obligatoire',
            ageConstraintValidationError: 'Les tranches d\'âge définies pour cette activité ne vous permettent pas de participer',
            noContingentSelectedError: 'Veuillez séléctionner un contingent à l\'une des étapes précédentes',
            contingentNotSelectableMessage: 'Cette option n\'est pas disponible pour votre âge',
            formatInvalide: 'Ce champ doit respecter un format valide',
            conditions: 'Vous devez accepter les conditions avant de pouvoir valider votre inscription',
            lienConditions: 'Voir les conditions',
            formatTel: 'Formats conseillés : 0032 xx xx xx xx ou 0032 x xx xx xx',
            formatMobile: 'Format conseillé : 0032 xxx xx xx xx',
            formatNrn: 'xx xx xx xxx-xx',
            trouverNrn: 'Vous trouverez votre numéro de registre national au dos de votre carte d\'identité',
            autre: 'Autre',
            btnSuivant: 'Continuer',
            btnPrecedent: 'Étape précédente',
            prixTotal: 'Prix total de votre inscription',
            erreurMessage: 'Une erreur s\'est produite',
            contingents: 'Options',
            contingentsLibres: 'Options libres',
            contingentsObligatoires: 'Options obligatoires',
            contingentComplet: 'COMPLET',
            periodeComplet: 'COMPLET',
            contingentAttente: 'Ce groupe est complet, inscrivez-vous tout de même sur liste d\'attente. Notre secrétariat vous recontactera si une place se libère.',
            periodeAttente: 'Cette période est complète, inscrivez-vous tout de même sur liste d\'attente. Notre secrétariat vous recontactera si une place se libère.',
            anijhan : 'Accessible aux personnes en situation de handicap',
            deposerDocument : 'Déposez ici votre document ou cliquez pour sélectionner votre document',
            erreurMaxPlaces : 'Vous êtes autorisé à réserver entre 1 et {nb_places} places sur cette activité',
            options: {
                obligatoire: 'Sélectionnez une des options proposées',
            },
            periodes: {
                du: 'du',
                au: 'au',
                obligatoire: 'Vous devez sélectionner au moins une des périodes proposées',
                garderie: 'Garderie',
                transport: 'Transport',
            },
            adresse: {
                adresse: 'Rue',
                ville: 'Ville',
                numero: 'Numéro',
                boite: 'Boîte',
                cp: 'Code postal/Localité',
                pays: 'Pays',
                facturationIdentique: 'Adresse de facturation identique à l\'adresse principale',
                urgenceIdentique: 'Adresse d\'urgence identique à l\'adresse principale',
                prenom : 'Prénom',
                nom : 'Nom',
                email : 'Email',
                tel : 'Téléphone',
                mobile : 'GSM',
            },
            sexes: {
                homme: 'Masculin',
                femme: 'Féminin',
            },
            pays: {
                belgique: 'Belgique',
                luxembourg: 'Luxembourg',
                france: 'France',
            },
            langues: {
                fr: 'Français',
                nl: 'Néerlandais',
                lu: 'Luxembourgeois',
                de: 'Allemand',
            },
            nationalites: {
                be: 'Belge',
                lu: 'Luxembourgeoise',
                de: 'Allemande',
                fr: 'Française',
            },
            resume: {
                titre: 'Résumé de votre inscription',
            },
            paiement: {
                parJour: ' / jour',
                parPeriode: ' / période',
            },
            btnPayerEnLigne: 'Payer mon inscription',
            nrn: 'Numéro de registre national',
            avantagesMC: 'Avantage MC',
            avantagesSwicthLabel: 'Je suis membre MC et je souhaite bénéficier de mon avantage',
            lienInscriptionAlternative: 'Lien vers processus d\'inscription alternatif',
            lienInscriptionForm: 'Revenir sur le formulaire d\'inscription',
            erreurDejaInscrit: '<p>Il semble que vous soyez déjà inscrit à cette activité, il n\'est pas possible d\'enregistrer votre inscription.</p>',
        }
    },
}
export default messages;
